@if (!isListEntry) {
  @for (fremdsystem of fremdsysteme | async | fremdsystemVisibility; track fremdsystem) {
    <a [href]="fremdsystem.url" class="btn btn-outline-primary btn-sm btn-actionpane" target="_blank"
      ><em [class]="fremdsystem.icon"></em> {{ fremdsystem.label }}</a
    >
  }
} @else {
  @for (fremdsystem of fremdsysteme | async | fremdsystemVisibility; track fremdsystem) {
    <a [href]="fremdsystem.url" [ngbTooltip]="fremdsystem.label.toString()" class="ms-2" target="_blank"
      ><em [class]="fremdsystem.icon"></em
    ></a>
  }
}
